




































import { namespace } from 'vuex-class';
import { Component, Vue, Prop } from 'vue-property-decorator';
import { ConfigService } from '@/services/ConfigService';
import { CART } from '@/store/types';
import CartPageStepper from './CartPageStepper.vue';
import { Step, Steps } from './Step';
import { NumberFormatter } from '@/services/NumberFormatter';
import { Big } from 'big.js';
import { Cart } from '@/services/cart/model/cart';
import { DependencyService } from '@/services/DependencyService';
import { ProductDto } from '@eurogast/hub-client-typescript';

const cart = namespace(CART);
@Component({ components: { CartPageStepper } })
export default class CartPageHeader extends Vue {
  @Prop({required: true})
  public localCartInfo: string;

  @Prop()
  public cartUrl: string;

  @Prop({ required: false, default: '/' })
  public shopUrl: string;

  @cart.State('cart')
  public cart: Cart;

  @cart.State('step')
  public step: Step;

  public username = ConfigService.getUsername();
  private cartService = DependencyService.getCartService();

  get stepName() {
    return Steps.getName(this.step);
  }

  get showPrice() {
    return !this.cartService.totalPrice.eq(new Big('0.0'));
  }

  get totalPrice() {
    return NumberFormatter.formatPrice(this.cartService.totalPrice);
  }

  get isLastStep() {
    return Steps.isLast(this.step);
  }

  get buttonCaption() {
    return Steps.getButtonCaption(this.step);
  }

  get customerId() {
    return ConfigService.currentCustomerId;
  }

  get isSubmissionDisabled() {
    return this.step === Step.CART && !this.availableCartItemsLength;
  }

  get availableCartItemsLength(): number {
    return this.cart.items.filter((it) => it.product.availability === ProductDto.AvailabilityEnum.ACTIVE).length;
  }

  public nextStep() {
    this.cartService.nextStepCartCheckout();
  }

  public toStartpage() {
    window.location.href = this.shopUrl;
  }
}
